"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));

var _react = _interopRequireDefault(require("react"));

var _ViewStyleControl = _interopRequireDefault(require("./ViewStyleControl"));

var _SortControl = _interopRequireDefault(require("./SortControl"));

var _netlifyCmsUiDefault = require("netlify-cms-ui-default");

var _core = require("@emotion/core");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const CollectionControlsContainer = (0, _styledBase.default)("div", {
  target: "e17kb5zm0",
  label: "CollectionControlsContainer"
})("display:flex;align-items:center;flex-direction:row-reverse;margin-top:22px;width:", _netlifyCmsUiDefault.lengths.topCardWidth, ";max-width:100%;& > div{margin-left:6px;}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9jb21wb25lbnRzL0NvbGxlY3Rpb24vQ29sbGVjdGlvbkNvbnRyb2xzLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQU04QyIsImZpbGUiOiIuLi8uLi8uLi8uLi9zcmMvY29tcG9uZW50cy9Db2xsZWN0aW9uL0NvbGxlY3Rpb25Db250cm9scy5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCc7XG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5pbXBvcnQgVmlld1N0eWxlQ29udHJvbCBmcm9tICcuL1ZpZXdTdHlsZUNvbnRyb2wnO1xuaW1wb3J0IFNvcnRDb250cm9sIGZyb20gJy4vU29ydENvbnRyb2wnO1xuaW1wb3J0IHsgbGVuZ3RocyB9IGZyb20gJ25ldGxpZnktY21zLXVpLWRlZmF1bHQnO1xuXG5jb25zdCBDb2xsZWN0aW9uQ29udHJvbHNDb250YWluZXIgPSBzdHlsZWQuZGl2YFxuICBkaXNwbGF5OiBmbGV4O1xuICBhbGlnbi1pdGVtczogY2VudGVyO1xuICBmbGV4LWRpcmVjdGlvbjogcm93LXJldmVyc2U7XG4gIG1hcmdpbi10b3A6IDIycHg7XG4gIHdpZHRoOiAke2xlbmd0aHMudG9wQ2FyZFdpZHRofTtcbiAgbWF4LXdpZHRoOiAxMDAlO1xuXG4gICYgPiBkaXYge1xuICAgIG1hcmdpbi1sZWZ0OiA2cHg7XG4gIH1cbmA7XG5cbmNvbnN0IENvbGxlY3Rpb25Db250cm9scyA9ICh7XG4gIGNvbGxlY3Rpb24sXG4gIHZpZXdTdHlsZSxcbiAgb25DaGFuZ2VWaWV3U3R5bGUsXG4gIHNvcnRhYmxlRmllbGRzLFxuICBvblNvcnRDbGljayxcbiAgc29ydCxcbn0pID0+IChcbiAgPENvbGxlY3Rpb25Db250cm9sc0NvbnRhaW5lcj5cbiAgICA8Vmlld1N0eWxlQ29udHJvbCB2aWV3U3R5bGU9e3ZpZXdTdHlsZX0gb25DaGFuZ2VWaWV3U3R5bGU9e29uQ2hhbmdlVmlld1N0eWxlfSAvPlxuICAgIHtzb3J0YWJsZUZpZWxkcy5sZW5ndGggPiAwICYmIChcbiAgICAgIDxTb3J0Q29udHJvbFxuICAgICAgICBmaWVsZHM9e3NvcnRhYmxlRmllbGRzfVxuICAgICAgICBjb2xsZWN0aW9uPXtjb2xsZWN0aW9ufVxuICAgICAgICBzb3J0PXtzb3J0fVxuICAgICAgICBvblNvcnRDbGljaz17b25Tb3J0Q2xpY2t9XG4gICAgICAvPlxuICAgICl9XG4gIDwvQ29sbGVjdGlvbkNvbnRyb2xzQ29udGFpbmVyPlxuKTtcblxuZXhwb3J0IGRlZmF1bHQgQ29sbGVjdGlvbkNvbnRyb2xzO1xuIl19 */"));

const CollectionControls = ({
  collection,
  viewStyle,
  onChangeViewStyle,
  sortableFields,
  onSortClick,
  sort
}) => (0, _core.jsx)(CollectionControlsContainer, null, (0, _core.jsx)(_ViewStyleControl.default, {
  viewStyle: viewStyle,
  onChangeViewStyle: onChangeViewStyle
}), sortableFields.length > 0 && (0, _core.jsx)(_SortControl.default, {
  fields: sortableFields,
  collection: collection,
  sort: sort,
  onSortClick: onSortClick
}));

var _default = CollectionControls;
exports.default = _default;